/**
 * Caché en memoria + deduplicación de peticiones GET concurrentes.
 * Reduce llamadas repetidas a /company, /categories, etc.
 */

const cache = new Map();
const inflight = new Map();

export function cachedRequest(key, fetcher, ttlMs = 60_000) {
  const now = Date.now();
  const hit = cache.get(key);
  if (hit && now - hit.time < ttlMs) {
    return Promise.resolve(hit.value);
  }

  if (inflight.has(key)) {
    return inflight.get(key);
  }

  const promise = Promise.resolve()
    .then(fetcher)
    .then((value) => {
      cache.set(key, { value, time: Date.now() });
      inflight.delete(key);
      return value;
    })
    .catch((err) => {
      inflight.delete(key);
      throw err;
    });

  inflight.set(key, promise);
  return promise;
}

export function invalidateRequestCache(keyOrPrefix) {
  const prefix = String(keyOrPrefix || '');
  for (const key of [...cache.keys()]) {
    if (key === prefix || key.startsWith(prefix)) {
      cache.delete(key);
    }
  }
  for (const key of [...inflight.keys()]) {
    if (key === prefix || key.startsWith(prefix)) {
      inflight.delete(key);
    }
  }
}

export function clearRequestCache() {
  cache.clear();
  inflight.clear();
}
